import { render, staticRenderFns } from "./today-badge-metric.vue?vue&type=template&id=7f61ff84&scoped=true&"
import script from "./today-badge-metric.vue?vue&type=script&lang=js&"
export * from "./today-badge-metric.vue?vue&type=script&lang=js&"
import style0 from "./today-badge-metric.vue?vue&type=style&index=0&id=7f61ff84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f61ff84",
  null
  
)

export default component.exports